import React, { useState, useEffect, useRef } from "react";
import { TextField, Button, Box, Modal } from "@mui/material";
import AccessibleTooltip from "../Tooltip/Tooltip.js";
import closeIcon from "../../assets/images/closeicon.svg";
import uploadFileImg from "../../assets/images/uploadFile.svg";
import "./style.scss";
import "../../assets/styles/form.scss";
import { useDispatch } from "react-redux";
import { addDeviceType, updateDeviceType } from "../../Actions/DeviceTypeAction.js";
import checkImg from "../../assets/images/check_circle.svg";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  paddingLeft: 4,
  paddingRight: 4,
};

/* -------------- FIX #1: MOVED appendFileOrURL HERE --------------- */
const appendFileOrURL = (formData, key, value) => {
  if (value instanceof File) {
    formData.append(key, value);       // new file
  } else if (typeof value === "string" && value.trim() !== "") {
    formData.append(key, value);       // existing URL
  }
};
/* ---------------------------------------------------------------- */

const FileBox = ({
  title,
  onChange,
  required,
  errorMsg,
  setErrorMsg,
  resetSignal = 0,
  defaultUrl = null,
}) => {
  const inputRef = useRef(null);
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    if (defaultUrl) {
      const nameFromUrl = defaultUrl.split("/").pop();
      setFileName(nameFromUrl);
      onChange(defaultUrl);
    }
  }, [defaultUrl]);

  useEffect(() => {
    if (!defaultUrl) {
      setFileName("");
      setErrorMsg("");
      if (inputRef.current) inputRef.current.value = "";
    }
  }, [resetSignal, defaultUrl]);

  const openFilePicker = () => inputRef.current?.click();

  const handleFileUpload = (e) => {
    setErrorMsg("");
    const file = e.target.files?.[0];
    if (!file) return;

    const allowedTypes = ["image/svg+xml"];
    if (!allowedTypes.includes(file.type)) {
      setErrorMsg("Only .SVG files are allowed.");
      e.target.value = "";
      return;
    }

    if (file.size > 1 * 1024 * 1024) {
      setErrorMsg("File size cannot exceed 1MB.");
      e.target.value = "";
      return;
    }

    setFileName(file.name);
    onChange(file);
  };

  return (
    <div
      className={`uploadBox ${errorMsg ? "errorBox" : ""}`}
      onClick={openFilePicker}
    >
      <label className="innerFields attachmentField" aria-hidden>
        <Button
          variant="contained"
          component="span"
          className="attachmentBtn"
          aria-label={title}
          onClick={(e) => {
            e.stopPropagation();
            openFilePicker();
          }}
        >
          <img src={uploadFileImg} alt="" aria-hidden="true" />
        </Button>
      </label>

      <input
        ref={inputRef}
        type="file"
        hidden
        accept="image/png, image/jpeg"
        onChange={handleFileUpload}
      />

      {!fileName && !errorMsg && (
        <>
          <p className="inst">{title}</p>
          <p className="type">(File type: .svg)</p>
          <p className="type">Max Size: 1MB</p>
        </>
      )}

      {fileName && !errorMsg && (
        <p className="selectedFileName">{fileName}</p>
      )}

      {errorMsg && <p className="fileError" role="alert">{errorMsg}</p>}
    </div>
  );
};

const AddNewDeviceType = (props) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const deviceInputRef = useRef(null);
  const [successMessage, setSuccessMessage] = useState(false);

  const [deviceName, setDeviceName] = useState("");
  const [deviceNameError, setDeviceNameError] = useState("");

  const [idleIcon, setIdleIcon] = useState(null);
  const [activeIcon, setActiveIcon] = useState(null);
  const [brokenIcon, setBrokenIcon] = useState(null);
  const [frame1, setFrame1] = useState(null);
  const [frame2, setFrame2] = useState(null);
  const [frame3, setFrame3] = useState(null);

  const [idleErr, setIdleErr] = useState("");
  const [activeErr, setActiveErr] = useState("");
  const [brokenErr, setBrokenErr] = useState("");
  const [frame1Err, setFrame1Err] = useState("");
  const [frame2Err, setFrame2Err] = useState("");
  const [frame3Err, setFrame3Err] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const dispatch = useDispatch();
  const [resetSignal, setResetSignal] = useState(0);

  const {
    openDeviceType,
    setOpenDeviceType,
    editDeviceType,
    openDeviceTypeModal,
    setEditDeviceType,
    setOpenDeviceTypeModal,
  } = props;

  const handleClose = () => {
    setOpenDeviceType(false);
    setSuccessMessage(false);
    setEditDeviceType("");
    setDeviceName("");
    setIdleIcon(null);
    setActiveIcon(null);
    setBrokenIcon(null);
    setFrame1(null);
    setFrame2(null);
    setFrame3(null);
    setDeviceNameError("");
    setOpenDeviceTypeModal("");
    setIdleErr("");
    setActiveErr("");
    setBrokenErr("");
    setFrame1Err("");
    setFrame2Err("");
    setFrame3Err("");
    setDescription("");
  setDescriptionError("");
    setResetSignal((s) => s + 1);
  };

    useEffect(() => {
      const onKeyDown = (e) => {
        if (e.key === "Escape" || e.key === "Esc") {
          if (tooltipOpen) {
            setTooltipOpen(false);
            e.preventDefault();
            e.stopPropagation();
          }
        }
      };
  
      if (openDeviceType) {
        window.addEventListener("keydown", onKeyDown);
      }
      return () => {
        window.removeEventListener("keydown", onKeyDown);
      };
    }, [openDeviceType, tooltipOpen]);

  const validateBeforeSubmit = () => {
    let isValid = true;

    if (!deviceName.trim()) {
      setDeviceNameError("Device name is required.");
      isValid = false;
    } else setDeviceNameError("");

    if (!idleIcon) {
      setIdleErr("Idle Icon is required.");
      isValid = false;
    }
    if (!activeIcon) {
      setActiveErr("Active Icon is required.");
      isValid = false;
    }
    if (!brokenIcon) {
      setBrokenErr("Broken Icon is required.");
      isValid = false;
    }
    if (!frame1) {
      setFrame1Err("Frame 1 is required.");
      isValid = false;
    }
    if (!frame2) {
      setFrame2Err("Frame 2 is required.");
      isValid = false;
    }
    if (!frame3) {
      setFrame3Err("Frame 3 is required.");
      isValid = false;
    }
    if (!description.trim()) {
      setDescriptionError("Description is required.");
      isValid = false;
    } else setDescriptionError("");
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateBeforeSubmit()) return;

    const payload = {
      name: deviceName,
     description: description,
      deleted: false,
      created_by: "SUPER_ADMIN",
      modified_by: "SUPER_ADMIN",
      render: true,
      triggering: true,
      monitor: false,
    };

    const formData = new FormData();
    formData.append("deviceType", JSON.stringify(payload));

    formData.append("idleIcon", idleIcon);
    formData.append("activeIcon", activeIcon);    
    formData.append("brokenIcon", brokenIcon);
    formData.append("animationFrames", frame1);
    formData.append("animationFrames", frame2);
    formData.append("animationFrames", frame3);

    try {
      await dispatch(addDeviceType(formData));
      setSuccessMessage(true);
    } catch (error) {
      console.error("Error adding device type:", error);
    }
  };

  const handleEditSubmit = async () => {
    if (!validateBeforeSubmit()) return;

    const payload = {
      name: deviceName,
      description: description,
      deleted: false,
      created_by: "SUPER_ADMIN",
      modified_by: "SUPER_ADMIN",
      render: true,
      triggering: true,
      monitor: false,
    };

    const formData = new FormData();
    formData.append("deviceType", JSON.stringify(payload));

    appendFileOrURL(formData, "idleIcon", idleIcon);
    appendFileOrURL(formData, "activeIcon", activeIcon);
    appendFileOrURL(formData, "brokenIcon", brokenIcon);

    if (frame1) formData.append("animationFrames", frame1);
    if (frame2) formData.append("animationFrames", frame2);
    if (frame3) formData.append("animationFrames", frame3);

    try {
      await dispatch(updateDeviceType(editDeviceType.row.id, formData));
      setSuccessMessage(true);
    } catch (error) {
      console.error("Error adding device type:", error);
    }
  };
  /* --------------------------------------------------------------------------- */

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (openDeviceType && deviceInputRef.current) {
        deviceInputRef.current.focus();
      }
    }, 200);
    return () => clearTimeout(timeoutId);
  }, [openDeviceType]);

  useEffect(() => {
    if (editDeviceType) {
      setDeviceName(editDeviceType.row.name || "");
      setIdleIcon(editDeviceType.row.idleIcon || null);
      setActiveIcon(editDeviceType.row.activeIcon || null);
      setBrokenIcon(editDeviceType.row.brokenIcon || null);
      setFrame1(editDeviceType.row.animationFrames?.[0] || null);
      setFrame2(editDeviceType.row.animationFrames?.[1] || null);
      setFrame3(editDeviceType.row.animationFrames?.[2] || null);
      setDescription(editDeviceType.row.description || "");
    }
  }, [editDeviceType]);

  return (
    <Modal
      open={openDeviceType}
      onClose={handleClose}
      disableEscapeKeyDown={tooltipOpen}
      className="globalForm addDeviceEntry"
    >
      <div role="none">
        <Box
          role="dialog"
          aria-labelledby="add-edit-device-title"
          aria-modal="true"
          sx={style}
          className="mainModalBox"
        >
          <div className="Modal_header">
            <h1 id="add-edit-device-title">{openDeviceTypeModal === "edit" ? "Edit Device Type" : "Add Device Type"}</h1>

            <AccessibleTooltip title="Close">
              <button
                data-testid="close-icon"
                ref={deviceInputRef}
                onClick={handleClose}
                className="close_button_modal"
                 aria-label="Close"
                 
                 onFocus={() => setTooltipOpen(true)}
                  onBlur={() => setTooltipOpen(false)}
                  onMouseEnter={() => setTooltipOpen(true)}
                  onMouseLeave={() => setTooltipOpen(false)}
              >
                <img src={closeIcon} alt="" aria-hidden="true" />
              </button>
            </AccessibleTooltip>
          </div>

          <div className="Modal_middle addDeviceTypewrapper">
            {!successMessage ? (
              <Box component="form" noValidate autoComplete="off">
                <TextField
                  fullWidth
                  label="Device Name"
                  id="deviceName_dt"
                  className="innerFields"
                  value={deviceName}
                  onChange={(e) => {
                    setDeviceName(e.target.value);
                    setDeviceNameError("");
                  }}
                  sx={{ marginBottom: "5px" }}
                />
                {deviceNameError && (
                  <p className="fileError" role="alert">{deviceNameError}</p>
                )}
                <TextField
                    fullWidth
                    label="Description"
                    id="deviceDescription_dt"
                    className="innerFields"
                    value={description}
                    onChange={(e) => {
                      setDescription(e.target.value);
                      setDescriptionError("");
                    }}
                    sx={{ marginBottom: "5px", marginTop: "10px" }}
                  />
                  {descriptionError && (
                    <p className="fileError" role="alert">{descriptionError}</p>
                  )}

                <div className="uploadFileWrapper">
                  <h3>Upload Icons</h3>

                  <div className="uploadRow" role="list">
                    <FileBox
                      title="Upload Idle Icon"
                      onChange={setIdleIcon}
                      required
                      errorMsg={idleErr}
                      setErrorMsg={setIdleErr}
                      resetSignal={resetSignal}
                      defaultUrl={editDeviceType?.row?.idleIcon}
                    />
                    <FileBox
                      title="Upload Active Icon"
                      onChange={setActiveIcon}
                      required
                      errorMsg={activeErr}
                      setErrorMsg={setActiveErr}
                      resetSignal={resetSignal}
                      defaultUrl={editDeviceType?.row?.activeIcon}
                    />
                    <FileBox
                      title="Upload Broken Icon"
                      onChange={setBrokenIcon}
                      required
                      errorMsg={brokenErr}
                      setErrorMsg={setBrokenErr}
                      resetSignal={resetSignal}
                      defaultUrl={editDeviceType?.row?.brokenIcon}
                    />
                  </div>

                  <h3 style={{ marginTop: "16px" }}>Animated Frames</h3>

                  <div className="uploadRow" role="list">
                    <FileBox
                      title="Upload Animated Frame 1"
                      onChange={setFrame1}
                      required
                      errorMsg={frame1Err}
                      setErrorMsg={setFrame1Err}
                      resetSignal={resetSignal}
                      defaultUrl={editDeviceType?.row?.animationFrames?.[0]}
                    />
                    <FileBox
                      title="Upload Animated Frame 2"
                      onChange={setFrame2}
                      required
                      errorMsg={frame2Err}
                      setErrorMsg={setFrame2Err}
                      resetSignal={resetSignal}
                      defaultUrl={editDeviceType?.row?.animationFrames?.[1]}
                    />
                    <FileBox
                      title="Upload Animated Frame 3"
                      onChange={setFrame3}
                      required
                      errorMsg={frame3Err}
                      setErrorMsg={setFrame3Err}
                      resetSignal={resetSignal}
                      defaultUrl={editDeviceType?.row?.animationFrames?.[2]}
                    />
                  </div>
                </div>
              </Box>
            ) : (
              <div className="emailsent-wrapper manageUser_details">
                <img src={checkImg} alt="" aria-hidden="true" />
                <h2>Success</h2>
                <p> Device type has {openDeviceTypeModal === "edit" ? "updated" : "created"} successfully.</p>
              </div>
            )}
          </div>

          <div className="Modal_footer">
            {!successMessage && (
              <Box sx={{ display: "flex" }}>
                <Button
                  variant="contained"
                  className="saveBtn"
                  onClick={
                    openDeviceTypeModal === "edit"
                      ? handleEditSubmit
                      : handleSubmit
                  }
                >
                  Save
                </Button>
              </Box>
            )}
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default AddNewDeviceType;
